import React, { useContext, useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { PostApi } from "../../api/api-service";
import { API_Path } from "../../Const";
import { AuthContext } from "../../context/AuthContext";

const bedsData = ["Studio", 1, 2, 3, 4, 5, 6, 7];
const urgencyData = ["This month", "Within 2 months", "Flexible"];

export default function SellerLeadsForm({ data, onHide }) {
    const { categoriesType, fetchCategoriesType, purposeType } = useContext(AuthContext);
    const [btnLoader, setBtnLoader] = useState(false);
    useEffect(() => {
        fetchCategoriesType();
    }, []);
    const setSubmitData = async (formData) => {
        let data = {
            propertyId: data?.data?.uId || "",
            resoan: formData?.resoan || "",
            fullName: formData.fullName,
            email: formData.email,
            message: formData.massage,
        };
        try {
            setBtnLoader(true);
            const res = await PostApi(API_Path.PropertyInquiry, data);
            if (res && res.data.success) {
                toast.success(res.data.message);
                onHide();
            } else toast.error(res.data.message);
            setBtnLoader(false);
        } catch (error) {
            setBtnLoader(false);
        }
    };
    return (
        <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" className="modal-details" show={data.flag} centered>
            <Modal.Header className="justify-content-between">
                <Modal.Title>Enter Property Details</Modal.Title>
                <button type="button" onClick={onHide} className="close-icon-style">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={{ purpose: "", fullName: "", email: "", massage: "" }}
                    validationSchema={Yup.object().shape({
                        resoan: Yup.string().required("resoan is required."),
                        fullName: Yup.string().required("Full name is required."),
                        email: Yup.string().email("Your email address must be in the format of name@domain.com.").required("Email is required."),
                        massage: Yup.string().required("Massage is required."),
                    })}
                    onSubmit={(values, { resetform }) => {
                        setSubmitData(values, resetform);
                    }}
                >
                    {(runform) => (
                        <Form onSubmit={runform.handleSubmit}>
                            <div className="row">
                                <div className="col-6">
                                    <div className="comn-input-main">
                                        <div className="pprs_box">
                                            <span>
                                                I am looking to <span className="text-danger">*</span>
                                            </span>
                                            <div className="tab-buttons hero-tab-btn mb-0">
                                                {purposeType.length > 0 &&
                                                    purposeType.map((pType, i) => (
                                                        <button
                                                            className={`tab-btn`}
                                                            // className={`tab-btn${bannerFilter.purpose.toLowerCase() === pType.type.toLowerCase() ? " active" : ""}`}
                                                            // onClick={() => filterCallBack(pType.type, "purpose")}
                                                            key={i}
                                                        >
                                                            {pType.oppositeName}
                                                        </button>
                                                    ))}
                                            </div>
                                        </div>
                                        <ErrorMessage name="resoan" component="span" className="error-message" />
                                    </div>
                                    <div className="comn-input-main">
                                        <label>
                                            Category & Type <span className="text-danger">*</span>
                                        </label>
                                        <div className="tab-buttons hero-tab-btn mb-0">
                                            {categoriesType.length > 0 &&
                                                categoriesType.map((pType, i) => (
                                                    <button
                                                        className={`tab-btn`}
                                                        // className={`tab-btn${bannerFilter.purpose.toLowerCase() === pType.type.toLowerCase() ? " active" : ""}`}
                                                        // onClick={() => filterCallBack(pType.type, "purpose")}
                                                        key={i}
                                                    >
                                                        {pType.name}
                                                    </button>
                                                ))}
                                        </div>
                                        <ErrorMessage name="fullName" component="span" className="error-message" />
                                    </div>
                                    <div className="comn-input-main">
                                        <label>Bedrooms</label>
                                        {bedsData.length > 0 &&
                                            bedsData.map((pType, i) => (
                                                <button
                                                    className={`tab-btn`}
                                                    // className={`tab-btn${bannerFilter.purpose.toLowerCase() === pType.type.toLowerCase() ? " active" : ""}`}
                                                    // onClick={() => filterCallBack(pType.type, "purpose")}
                                                    key={i}
                                                >
                                                    {pType}
                                                </button>
                                            ))}
                                    </div>
                                    <div className="comn-input-main">
                                        <label>Area(sqft)</label>
                                        <Field type="text" placeholder="Enter area" name="area" className="form-control" />
                                        <ErrorMessage name="area" component="span" className="error-message" />
                                    </div>
                                    <div className="comn-input-main">
                                        <label>
                                            Furnishing <span className="text-danger">*</span>
                                        </label>
                                        <Field type="text" placeholder="Enter furnishing" name="furnishing" className="form-control" />
                                        <ErrorMessage name="furnishing" component="span" className="error-message" />
                                    </div>
                                    <div className="comn-input-main">
                                        <label>Urgency</label>
                                        {urgencyData.length > 0 &&
                                            urgencyData.map((pType, i) => (
                                                <button
                                                    className={`tab-btn`}
                                                    // className={`tab-btn${bannerFilter.purpose.toLowerCase() === pType.type.toLowerCase() ? " active" : ""}`}
                                                    // onClick={() => filterCallBack(pType.type, "purpose")}
                                                    key={i}
                                                >
                                                    {pType}
                                                </button>
                                            ))}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="comn-input-main">
                                         <label>Expected Price (AED)</label>
                                        <Field type="text" placeholder="Enter expected price" name="price" className="form-control" />
                                        <ErrorMessage name="price" component="span" className="error-message" />
                                    </div>
                                    <div className="comn-input-main">
                                         <label>Note</label>
                                        <Field type="text" placeholder="Enter Your notes here" name="note" className="form-control" />
                                        <ErrorMessage name="note" component="span" className="error-message" />
                                    </div>
                                    <div className="comn-input-main">
                                        <label>Contact Details</label>
                                    </div>
                                    <div className="comn-input-main">
                                        <label>Name</label>
                                        <Field type="text" placeholder="Enter name" name="fullName" className="form-control" />
                                        <ErrorMessage name="fullName" component="span" className="error-message" />
                                    </div>
                                    <div className="comn-input-main">
                                        <label>Email</label>
                                        <Field type="text" placeholder="Enter email" name="email" className="form-control" />
                                        <ErrorMessage name="email" component="span" className="error-message" />
                                    </div>
                                    <div className="comn-input-main">
                                        <label>Phone Number</label>
                                        <Field type="text" placeholder="Enter phone number" name="phonenumber" className="form-control" />
                                        <ErrorMessage name="phonenumber" component="span" className="error-message" />
                                    </div>
                                </div>
                                <div className="send-btn  text-center">
                                    <button type="submit" className="button w-25" disabled={btnLoader}>
                                        SEND REPORT
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}
